export enum PageTypes {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  HYBRID = 'HYBRID',
}
